import { useEffect, useState } from 'react';
import api from '../../services/api';
import { useI18n } from '../../context/useI18n';
import VisualProgressBar from '../ui/VisualProgressBar';
import { CalendarDays } from 'lucide-react';

export default function D28dCycleBanner({ compact = false, hidePremiacion = false }) {
  const { t } = useI18n();
  const [ctx, setCtx] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    api.get('/d28d/cycle/me')
      .then((r) => setCtx(r.data?.data || null))
      .catch(() => setError(t('d28d.cycle.load_error', 'No se pudo cargar tu ciclo.')));
  }, [t]);

  if (error) return null;
  if (!ctx?.cycle) return null;

  const day = ctx.cycle_day ?? ctx.cycle?.day ?? 0;
  const total = ctx.cycle_total_days ?? 28;
  const pct = ctx.cycle_progress_pct ?? ctx.cycle?.progress_pct ?? 0;
  const name = ctx.cycle?.name || t('d28d.cycle.current', 'Ciclo activo');

  if (compact) {
    return (
      <div className="flex items-center gap-2 text-sm d28d-text-muted">
        <CalendarDays className="w-4 h-4 shrink-0" />
        <span>{name} · {t('d28d.cycle.day_of', 'Día {day} de {total}', { day, total })}</span>
      </div>
    );
  }

  return (
    <div className="card p-4 space-y-3 border border-[var(--d28d-yellow)]/30">
      <div className="flex flex-wrap items-start justify-between gap-2">
        <div>
          <p className="text-xs uppercase tracking-wider d28d-text-muted">{t('d28d.cycle.your_cycle', 'Tu ciclo')}</p>
          <h2 className="font-bold text-lg text-[var(--d28d-text)]">{name}</h2>
          {ctx.cycle?.label ? <p className="text-sm d28d-text-muted">{ctx.cycle.label}</p> : null}
        </div>
        <div className="text-right">
          <p className="text-2xl font-black text-[var(--d28d-yellow)]">{day}/{total}</p>
          <p className="text-xs d28d-text-muted">{t('d28d.cycle.days', 'días')}</p>
        </div>
      </div>
      <VisualProgressBar
        label={t('d28d.cycle.progress', 'Avance del ciclo')}
        value={pct}
        accent="lime"
        hint={ctx.cycle_end_date ? `${t('d28d.cycle.ends', 'Finaliza')}: ${ctx.cycle_end_date}` : ''}
      />
      {ctx.cycles_remaining != null && ctx.cycles_remaining > 0 ? (
        <p className="text-xs d28d-text-muted">
          {t('d28d.cycle.remaining', 'Ciclos restantes en tu plan')}: <strong>{ctx.cycles_remaining}</strong>
        </p>
      ) : null}
      {!hidePremiacion && ctx.premiacion_date ? (
        <p className="text-xs text-amber-800 bg-amber-50 rounded-lg px-3 py-2">
          {t('d28d.cycle.premiacion', 'Premiación')}: {ctx.premiacion_date}
        </p>
      ) : null}
    </div>
  );
}
